import type { FaireProductEntity } from "../../entity_types/product";

export const p_qbthqdbgpt: FaireProductEntity = {
  token: "p_qbthqdbgpt",
  type: "product",
  name: "Gold Cloud Pearl Tassel Huggie Earrings in Solid Copper",
  brandToken: "b_xd955m9fpf",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/88da1de0b290f576b1b40eb0400896bcf84fd10699cf3a2ae067b1b87fc1729c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/75b6f297f6c401cad7d5b9dd8a847dd81da7958ca67e1e4d2101144dd5eb5654.jpeg",
    "https://cdn.faire.com/fastly/9d8a802598115f731a0a80f9a691fde3070f7818e4229b478a7fbe05c125e226.jpeg",
    "https://cdn.faire.com/fastly/e40135211a490a4e26d509ada80c50711c80a522a374b4be49a7402eef2b98ef.jpeg",
    "https://cdn.faire.com/fastly/e0f4e0484d0f02d97fc5a1c881ea3ce8e18b3fb589b14fb3caaba927735bb34c.jpeg",
  ],
  priceDollars: 8,
  description:
    "Description & Details\n\nClouds are not just a meteorological phenomenon, but also a symbol deeply rooted in human culture. They play an important role in our lives, filling us with imagination and awe of the sky and the unknown world.\n\n• Material: High Quality Copper ∙ Pearl\n• Finish: Hypoallergenic ∙ Gold Plating\n• Dimensions: 15 x 22 mm each \n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:19.266Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
